import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "q-py-12 gap-sm q-px-md flex items-center justify-between" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "transition q-mb-none fs-13px fw-500" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "transition q-mb-none fs-13px fw-500" }

import { IActionMenuOption } from 'src/common/interfaces'
import { computed } from 'vue'

interface ICurrentData {
  [key: string]: unknown
}

interface IProps {
  menus: IActionMenuOption[]
  currentData: ICurrentData | ICurrentData[]
}

type Emits = { [key: string]: [currentData: { currentData: ICurrentData | ICurrentData[]; status?: boolean }] }


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseActionMenu' },
  __name: 'BaseActionMenu',
  props: {
    menus: {},
    currentData: {}
  },
  setup(__props: any) {


const props = __props


const activeObject = computed(() => {
  const result = {} as ICurrentData
  if (!Array.isArray(props.currentData))
    for (const menu of props.menus) {
      if (menu.children) result[menu.pk] = props.currentData[menu.pk]
    }
  else
    for (const menu of props.menus)
      if (menu.children) {
        const isActive = props.currentData.every((row) => row[menu.pk])
        result[menu.pk] = isActive
      }

  return result
})

return (_ctx: any,_cache: any) => {
  const _component_k_toggle = _resolveComponent("k-toggle")!
  const _component_k_divider = _resolveComponent("k-divider")!
  const _component_k_icon = _resolveComponent("k-icon")!
  const _component_q_slide_transition = _resolveComponent("q-slide-transition")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_popup_proxy, { class: "BaseActionMenu shadow-2" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menus, (menu) => {
        return (_openBlock(), _createElementBlock("div", {
          key: menu.pk,
          class: "BaseActionMenu__main dynamic-zoom",
          style: _normalizeStyle(menu.customMenuStyle)
        }, [
          (menu.children)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("p", {
                    class: _normalizeClass(["q-mb-none fs-13px fw-500", [activeObject.value[menu.pk] ? 'text-cool-gray-80' : 'text-cool-gray-70']])
                  }, _toDisplayString(activeObject.value[menu.pk] ? menu.activeTitle : menu.inactiveTitle), 3),
                  _createVNode(_component_k_toggle, {
                    "model-value": activeObject.value[menu.pk],
                    "onUpdate:modelValue": ($event: any) => (_ctx.$emit(menu.emit, { status: $event, currentData: __props.currentData }))
                  }, null, 8, ["model-value", "onUpdate:modelValue"])
                ]),
                (menu.children.length)
                  ? (_openBlock(), _createBlock(_component_q_slide_transition, { key: 0 }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", null, [
                          _createVNode(_component_k_divider, {
                            size: "lg",
                            color: "off-white-20"
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.children, (child, index) => {
                            return _withDirectives((_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: _normalizeClass(["BaseActionMenu__item BaseActionMenu__child-item q-py-12 q-px-md gap-12 flex items-center justify-between", [menu.disable ? 'BaseActionMenu__item--disable cursor-not-allowed' : 'cursor-pointer']]),
                              onClick: ($event: any) => (!menu.disable && _ctx.$emit(child.emit, { currentData: __props.currentData }))
                            }, [
                              _createElementVNode("p", _hoisted_3, _toDisplayString(child.title), 1),
                              (child.icon)
                                ? (_openBlock(), _createBlock(_component_k_icon, {
                                    key: 0,
                                    size: "20px",
                                    name: child.icon,
                                    color: child.disable ? 'cool-gray-50' : child.color ? child.color : 'cool-gray-70'
                                  }, null, 8, ["name", "color"]))
                                : _createCommentVNode("", true)
                            ], 10, _hoisted_2)), [
                              [_directive_close_popup, menu?.closePopup]
                            ])
                          }), 128))
                        ], 512), [
                          [_vShow, activeObject.value[menu.pk]]
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ], 64))
            : _withDirectives((_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["BaseActionMenu__item q-py-12 q-px-md gap-12 flex items-center justify-between", [menu.disable ? 'BaseActionMenu__item--disable cursor-not-allowed' : 'cursor-pointer']]),
                onClick: ($event: any) => (!menu.disable && _ctx.$emit(menu.emit, { currentData: __props.currentData }))
              }, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(menu.title), 1),
                (menu.icon)
                  ? (_openBlock(), _createBlock(_component_k_icon, {
                      key: 0,
                      size: "20px",
                      name: menu.icon,
                      color: menu.disable ? 'cool-gray-50' : menu.color ? menu.color : 'cool-gray-70'
                    }, null, 8, ["name", "color"]))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_4)), [
                [_directive_close_popup, menu?.closePopup]
              ])
        ], 4))
      }), 128))
    ]),
    _: 1
  }))
}
}

})